import type { JSX } from 'react';
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';
import { SrdArticle, type SrdArticleKind } from '../../systems/dnd5e/components/SrdPanel';
import { useI18n } from '../../i18n';

export interface SrdArticleTarget {
  readonly kind: SrdArticleKind;
  readonly slug: string;
}

/**
 * An SRD article opened from the search — at the table and in Подготовка alike (Подготовка has no SRD panel). The
 * article is the SRD panel's own detail view; «← Back» closes the dialog.
 */
export function SrdArticleDialog(props: {
  readonly target: SrdArticleTarget | null;
  readonly onClose: () => void;
  readonly onSpawn?: (slug: string, withSheet: boolean, name?: string) => void;
}): JSX.Element {
  const { target, onClose, onSpawn } = props;
  const { t } = useI18n();
  return (
    <Dialog open={target !== null} onOpenChange={(open): void => { if (!open) onClose(); }}>
      <DialogContent size="lg" className="max-h-[calc(100vh-6rem)] overflow-hidden p-0" data-testid="srd-article">
        <DialogTitle className="sr-only">{t('srd.title')}</DialogTitle>
        {target === null ? null : (
          <div className="flex max-h-[calc(100vh-6rem)] min-h-0 flex-col">
            <SrdArticle kind={target.kind} slug={target.slug} onBack={onClose} onSpawn={onSpawn} />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
